import React from "react";
import { Box, CssBaseline, Toolbar, Typography } from "@mui/material";
import { Outlet, useLocation } from "react-router-dom"; // Added useLocation
import AdminSidebar from "../components/admin/Adminsidebar";

const AdminHome = () => {
  const location = useLocation(); // Get the current route

  // Check if the current route is the admin homepage (e.g., "/admin" or "/admin/home")
  const isAdminHome = location.pathname === "/admin" || location.pathname === "/admin/home";

  return (
    <Box sx={{ display: "flex", backgroundColor: "#ffffff", minHeight: "100vh" }}>
      <CssBaseline />
      <AdminSidebar />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          margin: 6,
          mt: 0,
          color: "#ffffff", // White text to match the dark theme
        }}
      >
        {/* Conditionally render the heading only on /admin or /admin/home */}
        {isAdminHome && (
          <Typography
            variant="h4"
            sx={{
              marginBottom: 2,
              marginTop: 30,
              fontWeight: "bold",
              color: "#7d1aed", // Pinkish color to match your app's theme
              fontFamily: "'Poppins', sans-serif",
            }}
          >
            Cinevest Admin Dashboard
          </Typography>
        )}
        <Toolbar />
        <Outlet />
      </Box>
    </Box>
  );
};

export default AdminHome;